import styled from 'styled-components';

const ContainerForm = styled.div`
  width: 100%;
  input[type='text'],
  input[type='number'],
  textarea,
  select {
    border: none;
    background-image: none;
    background-color: transparent;
    -webkit-box-shadow: none;
    -moz-box-shadow: none;
    box-shadow: none;
    background: #ffffff;
    border: 1px solid #7a959f;
    box-sizing: border-box;
    border-radius: 4px;
    width: 100%;
    outline: none;
  }

  input[type='text'],
  input[type='number'] {
    height: 40px;
    padding: 10px 16px;
    caret-color: #4318cd;
    color: #161d1f;
    font-size: 14px;
    line-height: 20px;
  }

  textarea {
    height: 102px;
    resize: none;
    padding: 12px 16px;
    caret-color: #4318cd;
    color: #161d1f;
    font-size: 14px;
    line-height: 20px;
  }

  select {
    height: 40px;
    padding: 10px 16px;
  }

  option {
    height: 40px;
    padding: 10px 16px;
  }

  input[type='text'].error,
  input[type='number'].error,
  textarea.error,
  select.error {
    border: 1px solid #e8212b;
  }

  input[type='text']::placeholder,
  input[type='number']::placeholder,
  textarea::placeholder {
    color: blue;
    font-size: 14px;
    line-height: 20px;
    color: #4f6168;
  }

  input[type='text']:hover,
  input[type='number']:hover,
  textarea:hover,
  select:hover {
    border: 1px solid #4318cd;
  }

  input[type='text']:focus,
  input[type='number']:focus,
  textarea:focus,
  select:focus {
    border: 1px solid #4318cd;
  }

  input[type='text'].error:hover,
  input[type='number'].error:hover,
  textarea.error:hover,
  select.error:hover {
    border: 1px solid #e8212b;
  }
  --select-border: #777;
  --select-focus: #d5e5f0;
  --select-arrow: none;

  input[type='text'].error:focus,
  input[type='number'].error:focus,
  textarea.error:focus,
  select.error:focus {
    border: 1px solid #e8212b;
  }
  .alert {
    color: #e8212b;
  }
  .alert cc-icon {
    margin-right: 4px;
  }
  .warning cc-icon {
    color: #977100;
    margin-right: 4px;
  }
`;

export { ContainerForm };
